<template>
  <img class="comp-icon" :width="width" :height="height || width" :src="productLogo" alt :onerror="errorImg">
</template>

<script>
  import { ApiService } from "@/service";

  import defaultImg from '/@/assets/images/nocomp.png'

  export default {
    name: "comp-icon",
    props: {
      src: {
        required: true
      },
      width: { default: 0 },
      height: { default: 0 },
    },
    data() {
      return {
        errorImg: `this.src="${defaultImg}"`
      };
    },
    computed: {
      productLogo() {
        if (!this.src) {
          return '';
        }
        if(/\.[a-zA-Z]+$/.test(this.src)) {
          return this.src;
        } else {
          return `${ApiService.ImageHost}/${this.src}_${this.width}x${this.height||this.width}.jpg`;
        }
      }
    }
  };
</script>
<style scoped="scoped">
  .comp-icon {
    vertical-align: middle;
    object-fit: contain;
  }
</style>
